import BaseModel from "@/models/BaseModel";

export enum BusinessType {
    COLLECTION = 1,
    PRECOLLECTION = 2,
    SERVICE = 3
}

export default class SystemModel extends BaseModel {
    public static isCollection(system: { businessType: number }) {
        return system && system.businessType === BusinessType.COLLECTION;
    }

    public static isPreCollection(system: { businessType: number }) {
        return system && system.businessType === BusinessType.PRECOLLECTION;
    }

    public static isService(system: { businessType: number }) {
        return system && system.businessType === BusinessType.SERVICE;
    }
}

export interface System {
    systemId: number;
    systemName: string;
    businessType: number;
    businessArea: string;
    systemTypeId: number;
    systemDescription: string;
    country: {
        countryId: number;
        countryName: string;
    };

    showFee: boolean;
    maxFee: number;
    maxRegCapital: number;

}
